import { Action, createReducer, on } from '@ngrx/store';
import {
  adminUpdateUser,
  adminUpdateUserFailed,
  adminUpdateUserSuccess,
  createUser,
  createUserSuccess,
  createUserFailed,
  readAllSuccess,
  readAllFailed,
  loadUsers,
  resetUsers,
} from '../actions/user.actions';
import { UserQueryDto } from '../../../api/models/user-query-dto';

export interface UserState {
  users: UserQueryDto[];
  loading: boolean;
  loaded: boolean;
  creating: boolean;
  updating: boolean;
  error?: unknown;
}

export const initialState: UserState = {
  users: [],
  loading: false,
  loaded: false,
  creating: false,
  updating: false,
  error: undefined,
};

const userReducer = createReducer(
  initialState,

  on(loadUsers, (state) => ({ ...state, loading: true, error: undefined })),
  on(readAllSuccess, (state, { users }) => ({
    ...state,
    users,
    loading: false,
    loaded: true,
    error: undefined,
  })),
  on(readAllFailed, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(createUser, (state) => ({ ...state, creating: true, error: undefined })),
  on(createUserSuccess, (state, { newUser }) => ({
    ...state,
    users: [...state.users, newUser],
    creating: false,
    error: undefined,
  })),
  on(createUserFailed, (state, { error }) => ({ ...state, creating: false, error })),

  on(adminUpdateUser, (state) => ({ ...state, updating: true, error: undefined })),
  on(adminUpdateUserSuccess, (state) => ({ ...state, updating: false, error: undefined })),
  on(adminUpdateUserFailed, (state, { error }) => ({ ...state, updating: false, error })),

  on(resetUsers, () => initialState)
);

export function reducer(state: UserState | undefined, action: Action) {
  return userReducer(state, action);
}
